import { IssueModel } from 'shared/domain/issue/issueModel';

export function hasLocalId(
  issue: IssueModel
): issue is IssueModel & { localId: number | string } {
  return 'localId' in issue && issue.localId !== undefined && issue.localId !== null;
}

export function resolveIssueNavigationId(
  issue: IssueModel | undefined
): string | undefined {
  if (!issue) {
    return undefined;
  }

  if (issue._id) {
    return issue._id;
  }

  if (hasLocalId(issue)) {
    return String(issue.localId);
  }

  return undefined;
}
